import { useContext, useEffect, useState } from "react";
import { fuelOption } from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddManager = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { save } = useService("Data", "media");
  const { getLoggedInUserData } = useService("User");
  const { setTitle } = useService("Meta");
  const { getBase64, generateUID, showAlert } = useService("Misc");
  const { isValidVehicleRegistrationNumber } = useService("Validation");
  const { urlToSplitData, getLocationData } = useService("Router");
  const { getCar, addCar, updateCar } = useService("Car");
  const user = getLoggedInUserData();
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [registrationNo, setregistrationNo] = useState<string>("");
  const [registrationDate, setregistrationDate] = useState<string>("");
  const [chassisNo, setchassisNo] = useState<string>("");
  const [engineNo, setengineNo] = useState<string>("");
  const [ownerName, setownerName] = useState(user.name);
  const [vehicleClass, setvehicleClass] = useState<string>("");
  const [activeFuelType, setactiveFuelType] = useState<number>(0);
  const [fuelType, setfuelType] = useState(fuelOption[0]);
  const [maker, setmaker] = useState<string>("");
  const [fitness, setfitness] = useState<string>("");
  const [mvTax, setmvTax] = useState<string>("");
  const [insurance, setinsurance] = useState<string>("");
  const [pucc, setpucc] = useState<string>("");
  const [emission, setemission] = useState<string>("");
  const [rcStatus, setrcStatus] = useState<string>("");
  const [financed, setfinanced] = useState<string>("");
  const [showForm, setshowForm] = useState<boolean>(false);
  const [file, setfile] = useState(null);
  const [fileArray, setfileArray] = useState([]);
  const [userData, setuserData] = useState(null);
  const [uid, setuid] = useState<string>("");
  const [showInsurance, setshowInsurance] = useState<boolean>(true);
  const [showRc, setshowRc] = useState<boolean>(true);
  const [rcImage, setrcImage] = useState<string>("");
  const [insuranceImage, setinsuranceImage] = useState<string>("");

  setTitle(t("addManager"));
  useEffect(() => {
    const urlData = urlToSplitData(getLocationData().pathname);
    if (urlData[2] === "edit" || urlData[2] === "view") {
      let query = {
        uid: urlData[3],
      };
      getCarData(query, urlData[2]);
    }
  }, []);

  const getCarData = async (query, mode) => {
    const result = await getCar(query);
    if (result.status) {
      if (result.data?.length > 0) {
        let userData = result.data[0];
        if (
          typeof userData.rcImage === "undefined" ||
          userData.rcImage === ""
        ) {
          setshowRc(false);
          userData.rcImage = "[]";
        }
        if (
          typeof userData.insuranceImage === "undefined" ||
          userData.insuranceImage === ""
        ) {
          setshowInsurance(false);
          userData.insuranceImage = "[]";
        }
        setmode(mode);
        setregistrationNo(userData.registrationNo);
        setregistrationDate(userData.registrationDate);
        setchassisNo(userData.chassisNo);
        setengineNo(userData.engineNo);
        setownerName(userData.ownerName);
        setvehicleClass(userData.vehicleClass);
        setmaker(userData.maker);
        setfitness(userData.fitness);
        setmvTax(userData.mvTax);
        setinsurance(userData.insurance);
        setpucc(userData.pucc);
        setfuelType(
          typeof userData.fuelType === "object"
            ? JSON.parse(userData.fuelType)
            : fuelOption[activeFuelType]
        );
        setemission(userData.emission);
        setrcStatus(userData.rcStatus);
        setfinanced(userData.financed);
        setuserData(JSON.parse(userData.userData));
        setuid(userData.uid);
        setshowForm(true);
        setrcImage(userData.rcImage);
        setinsuranceImage(userData.insuranceImage);
      }
    }
  };

  const handleChange = (fuelType) => {
    setfuelType(fuelType);
  };

  const addManager = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      carObject = {
        registrationNo: registrationNo,
        registrationDate: registrationDate,
        chassisNo: chassisNo,
        engineNo: engineNo,
        ownerName: ownerName,
        vehicleClass: vehicleClass,
        maker: maker,
        fitness: fitness,
        mvTax: mvTax,
        insurance: insurance,
        pucc: pucc,
        fuelType: JSON.stringify(fuelType),
        emission: emission,
        rcImage: rcImage,
        insuranceImage: insuranceImage,
        rcStatus: rcStatus,
        financed: financed,
        userData: JSON.stringify(userData),
        uid: mode === "add" ? generateUID() : uid,
        ownerId: user.uid,
      };
    if (registrationNo === "") {
      errorMsg = "Please enter car Registration Number!";
      error = true;
    } else if (fuelType === "") {
      errorMsg = "Please select car fuel";
      error = true;
    } else if (!isValidVehicleRegistrationNumber(registrationNo)) {
      errorMsg = t("errorMsg.validate.vehicleRegistrationNumber");
      error = true;
    }
    if (!error) {
      if (mode === "add") {
        const result = await addCar(carObject);
        if (result.status) {
          showAlert({ type: "success", msg: "Manager added successfully!" });
          navigateTo({ route: "/manager/list" });
        } else showAlert({ type: "error", msg: "Unable to add car!" });
      } else {
        let data = {
          query: JSON.stringify({ uid }),
          userData: JSON.stringify(carObject),
        };
        const result = await updateCar(data);
        if (result.status) {
          showAlert({ type: "success", msg: "Manager updated successfully!" });
          localStorage.removeItem("activeCar");
          navigateTo({ route: "/manager/list" });
        } else showAlert({ type: "error", msg: "Unable to update car!" });
      }
    } else showAlert({ type: "error", msg: errorMsg });
  };

  const uploadCall = async (file, activeUploadType) => {
    let error = false,
      errorMsg = "";
    if (!error) {
      file.uid = generateUID();
      const fileResult = await save(file);
      if (fileResult.status) {
        let carObject = null;
        if (activeUploadType === "rc") {
          carObject = {
            rcImage: '["' + fileArray[0].fileName + '"]',
          };
        } else {
          carObject = {
            insuranceImage: '["' + fileArray[0].fileName + '"]',
          };
        }
        let data = {
          query: JSON.stringify({ uid: userData.uid }),
          userData: JSON.stringify(carObject),
        };
        const result = await updateCar(data);
        if (result.status) {
          setfileArray([]);
          setfile([]);
          userData.image = carObject.image;
          if (activeUploadType === "rc") {
            setrcImage(carObject.rcImage);
            setshowRc(true);
          } else {
            setinsuranceImage(carObject.insuranceImage);
            setshowInsurance(true);
          }
        } else
          showAlert({ type: "error", msg: t("errorMsg.fail.imageUpdate") });
      } else showAlert({ type: "error", msg: t("errorMsg.fail.imageUpdate") });
    } else showAlert({ type: "error", msg: errorMsg });
  };

  return {
    addManager,
    mode,
    fuelOption,
    registrationNo,
    setregistrationNo,
    ownerName,
    setownerName,
    vehicleClass,
    setvehicleClass,
    fuelType,
    handleChange,
    maker,
    setmaker,
  };
};
